import forEachElement from '../elements/forEachElement';
import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import getFieldValue from './elements/getFieldValue';
import getForm from './elements/getForm';
import replaceLabelText from './elements/replaceLabelText';
import * as eventsModel from './models/events';

const gbzipcodeRE = new RegExp(
  '^([Gg][Ii][Rr] 0[Aa]{2})|' +
  '((([A-Za-z][0-9]{1,2})|' +
  '(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|' +
  '(([A-Za-z][0-9][A-Za-z])|'+
  '([A-Za-z][A-Ha-hJ-Yj-y][0-9]?' +
  '[A-Za-z]))))[ ]{0,1}[0-9][A-Za-z]{2})$'
);

const cazipcodeRE = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
const uszipcodeRE = /^[0-9]{5}(?:-[0-9]{4})?$/;
const intzipcodeRE = /^([\w- ]){4,10}$/;

function zipCodeFormat(countryCode) {
  switch(countryCode) {
    case 'US': return uszipcodeRE;
    case 'CA': return cazipcodeRE;
    case 'GB': return gbzipcodeRE;
    default: return intzipcodeRE;
  }
}

function zipCodeMaxLength(countryCode) {
  if(countryCode === 'US') { return 5; }
  if(countryCode === 'CA') { return 7; }
  if(countryCode === 'GB') { return 8; }
  return 10;
}

function zipCodeLabel(countryCode) {
  if(!countryCode || countryCode === 'US') { return 'ZIP Code'; }
  return 'Postal Code';
}

function setupZipCodeField(field) {
  const form = getForm(field);
  let countryCode = getFieldValue(form, 'country_code') || 'US';
  const input = field.querySelector(selectors.fields.join());
  const label = field.querySelector(selectors.formFieldLabel);

  if (label) {
    replaceLabelText(label, zipCodeLabel(countryCode));
  }

  if (input) {
    input.maxLength = zipCodeMaxLength(countryCode);
    input.pattern = zipCodeFormat(countryCode).source;
  }
}

function changeInput(event) {
  event.target.value = event.target.value.toUpperCase();
}

export function setupZipCodePanel() {
  forEachElement(selectors.zipCodeField, setupZipCodeField);
}

setupZipCodePanel();
addTargetEventListener(eventsModel.events.showStep, selectors.panel, setupZipCodePanel);
addTargetEventListener('change', `${selectors.zipCodeField} input`, changeInput);
